import styles from "./WPR_Sample_Image_Section.module.css";
import { useState } from "react";

//Sample Images

import sample_1 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P1/1.png";
import sample_2 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P1/2.png";
import sample_3 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P1/3.png";
import sample_4 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P1/4.png";
import sample_5 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P1/5.png";
import sample_6 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P1/6.png";
import sample_7 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P1/7.png";
import sample_8 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P1/8.png";
import sample_9 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P1/9.png";

import sample2_1 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P2/1.png";
import sample2_2 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P2/2.png";
import sample2_3 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P2/3.png";
import sample2_4 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P2/4.png";
import sample2_5 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P2/5.png";
import sample2_6 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P2/6.png";
import sample2_7 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P2/7.png";
import sample2_8 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P2/8.png";
import sample2_9 from "../../../assets/images/edit_screen/WoodenPlateRectangle/P2/9.png";

const EditScreenSamplePictureZoomThumb = ({ title, subtitle, imagePack }) => {
  const imageArray1 = [
    sample_1,
    sample_2,
    sample_3,
    sample_4,
    sample_5,
    sample_6,
    sample_7,
    sample_8,
    sample_9,
  ];
  const imageArray2 = [
    sample2_1,
    sample2_2,
    sample2_3,
    sample2_4,
    sample2_5,
    sample2_6,
    sample2_7,
    sample2_8,
    sample2_9,
  ];

  const textArray1 = [
    "1. クラシカル明朝体・ベージュ",
    "2. シンプルゴシック体・ベージュ",
    "３. 手書きゴシック体・白",
    "4. やわらか筆記体・黒",
    "5. クール筆記体・白",
    "6. 丸め筆記体・グレー",
    "7. レトロ明朝体（縦）・グレー",
    "8. 丸ゴシック体（横）・グレー",
    "9. 手書きゴシック体（縦）・黒",
  ];

  const textArray2 = [
    "1. クラシカル明朝体・ベージュ",
    "2. シンプルゴシック体・白",
    "３. 手書きゴシック体・ベージュ",
    "4. やわらか筆記体・グレー",
    "5. クール筆記体・白",
    "6. 丸め筆記体・グレー",
    "7. レトロ明朝体（縦）・グレー",
    "8. 丸ゴシック体（縦）・黒",
    "9. 手書きゴシック体（横）・グレー",
  ];
  const textArray = imagePack === 1 ? textArray1 : textArray2;
  const picArray = imagePack === 1 ? imageArray1 : imageArray2;
  const [thumbPic, setThumbPic] = useState(null);
  console.log("IMAGEPACK:");
  console.log(imagePack);
  const next_pic = () => {
    setThumbPic(thumbPic >= 8 ? 0 : thumbPic + 1);
  };
  const back_pic = () => {
    setThumbPic(thumbPic <= 0 ? 8 : thumbPic - 1);
  };
  return (
    <div className={styles.main}>
      <div className={styles.header_section}>
        <div name={title} className={styles.sample_section1_header}>
          {title}
        </div>
        <div className={styles.sample_section1_subtitle}>{subtitle}</div>
      </div>
      <div className={styles.pictures_main}>
        {imagePack === 1 && (
          <div className={styles.pictures_m1}>
            <div className={styles.p1_r1}>
              <div
                onClick={() => {
                  setThumbPic(0);
                }}
                className={styles.pic01}
              >
                <img
                  src={imageArray1[0]}
                  style={{ height: "366px", width: "503px" }}
                  alt="img01"
                />
                <div>{textArray[0]}</div>
              </div>
              <div
                onClick={() => {
                  setThumbPic(1);
                }}
                className={styles.pic02}
              >
                <img
                  src={imageArray1[1]}
                  style={{ height: "366px", width: "269px" }}
                  alt="img01"
                />
                <div>{textArray[1]}</div>
              </div>
              <div
                onClick={() => {
                  setThumbPic(2);
                }}
                className={styles.pic02}
              >
                <img
                  src={imageArray1[2]}
                  style={{ height: "366px", width: "269px" }}
                  alt="img01"
                />
                <div>{textArray[2]}</div>
              </div>
            </div>
            <div className={styles.p1_r1}>
              <div
                onClick={() => {
                  setThumbPic(3);
                }}
                className={styles.pic02}
              >
                <img
                  src={imageArray1[3]}
                  style={{ height: "366px", width: "269px" }}
                  alt="img01"
                />
                <div>{textArray[3]}</div>
              </div>
              <div
                onClick={() => {
                  setThumbPic(4);
                }}
                className={styles.pic02}
              >
                <img
                  src={imageArray1[4]}
                  style={{ height: "366px", width: "269px" }}
                  alt="img01"
                />
                <div>{textArray[4]}</div>
              </div>
              <div
                onClick={() => {
                  setThumbPic(5);
                }}
                className={styles.pic01}
              >
                <img
                  src={imageArray1[5]}
                  style={{ height: "366px", width: "503px" }}
                  alt="img01"
                />
                <div>{textArray[5]}</div>
              </div>
            </div>
            <div className={styles.p1_r1}>
              <div
                onClick={() => {
                  setThumbPic(6);
                }}
                className={styles.pic01}
              >
                <img
                  src={imageArray1[6]}
                  style={{ height: "366px", width: "503px" }}
                  alt="img01"
                />
                <div>{textArray[6]}</div>
              </div>
              <div
                onClick={() => {
                  setThumbPic(7);
                }}
                className={styles.pic02}
              >
                <img
                  src={imageArray1[7]}
                  style={{ height: "366px", width: "269px" }}
                  alt="img01"
                />
                <div>{textArray[7]}</div>
              </div>
              <div
                onClick={() => {
                  setThumbPic(8);
                }}
                className={styles.pic02}
              >
                <img
                  src={imageArray1[8]}
                  style={{ height: "366px", width: "269px" }}
                  alt="img01"
                />
                <div>{textArray[8]}</div>
              </div>
            </div>
          </div>
        )}
        {imagePack === 2 && (
          <div className={styles.pictures_m1}>
            <div className={styles.p1_r2}>
              <div
                onClick={() => {
                  setThumbPic(0);
                }}
                className={styles.pic03}
              >
                <img
                  src={imageArray2[0]}
                  style={{ height: "362px", width: "446px" }}
                  alt="img01"
                />
                <div>{textArray[0]}</div>
              </div>
              <div
                onClick={() => {
                  setThumbPic(1);
                }}
                className={styles.pic04}
              >
                <img
                  src={imageArray2[1]}
                  style={{ height: "362px", width: "293px" }}
                  alt="img01"
                />
                <div>{textArray[1]}</div>
              </div>
              <div
                onClick={() => {
                  setThumbPic(2);
                }}
                className={styles.pic04}
              >
                <img
                  src={imageArray2[2]}
                  style={{ height: "362px", width: "293px" }}
                  alt="img01"
                />
                <div>{textArray[2]}</div>
              </div>
            </div>
            <div className={styles.p1_r2}>
              <div
                onClick={() => {
                  setThumbPic(3);
                }}
                className={styles.pic04}
              >
                <img
                  src={imageArray2[3]}
                  style={{ height: "362px", width: "293px" }}
                  alt="img01"
                />
                <div>{textArray[3]}</div>
              </div>
              <div
                onClick={() => {
                  setThumbPic(4);
                }}
                className={styles.pic04}
              >
                <img
                  src={imageArray2[4]}
                  style={{ height: "362px", width: "293px" }}
                  alt="img01"
                />
                <div>{textArray[4]}</div>
              </div>
              <div
                onClick={() => {
                  setThumbPic(5);
                }}
                className={styles.pic03}
              >
                <img
                  src={imageArray2[5]}
                  style={{ height: "362px", width: "446px" }}
                  alt="img01"
                />
                <div>{textArray[5]}</div>
              </div>
            </div>
            <div className={styles.p1_r2}>
              <div
                onClick={() => {
                  setThumbPic(6);
                }}
                className={styles.pic03}
              >
                <img
                  src={imageArray2[6]}
                  style={{ height: "362px", width: "446px" }}
                  alt="img01"
                />
                <div>{textArray[6]}</div>
              </div>
              <div
                onClick={() => {
                  setThumbPic(7);
                }}
                className={styles.pic04}
              >
                <img
                  src={imageArray2[7]}
                  style={{ height: "362px", width: "293px" }}
                  alt="img01"
                />
                <div>{textArray[7]}</div>
              </div>
              <div
                onClick={() => {
                  setThumbPic(8);
                }}
                className={styles.pic04}
              >
                <img
                  src={imageArray2[8]}
                  style={{ height: "362px", width: "293px" }}
                  alt="img01"
                />
                <div>{textArray[8]}</div>
              </div>
            </div>
          </div>
        )}
        {thumbPic !== null && (
          <div className={styles.modal_pic}>
            <img
              src={picArray[thumbPic]}
              className={styles.thumb_image}
              alt="thumb"
            />
            <div className={styles.thumb_text}>{textArray[thumbPic]}</div>
            <span
              onClick={back_pic}
              className={`${styles.arrow_icon_left} material-icons`}
            >
              keyboard_arrow_left
            </span>
            <span
              onClick={next_pic}
              className={`${styles.arrow_icon_right} material-icons`}
            >
              keyboard_arrow_right
            </span>
            <div onClick={() => setThumbPic(null)} className={styles.cross_div}>
              <ion-icon className={styles.cross_icon} name="close"></ion-icon>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default EditScreenSamplePictureZoomThumb;
